import { useDispatch, useSelector } from "react-redux";
import Breadcrumb from "./Breadcrumb";
import { removeItem } from "../../store/breadcrumb/breadcrumbActions";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core";
import Container from "@material-ui/core/Container";

const useStyles = makeStyles((theme) => ({
  paper: {
    display: "flex",
    flexWrap: "wrap",
    "& > *": {
      //margin: theme.spacing(1),
      //width: "100%",
      height: theme.spacing(5),
    },
  },
  breadcrumbContainer: {
    marginTop: "10px",
    marginBottom: "10px",
  },
}));

export default function BreadcrumbIndex() {
  const classes = useStyles();
  const breadcrumb = useSelector((state) => state.breadcrumb.breadcrumbs);
  const dispatch = useDispatch();
  const history = useHistory();

  const navigateBreadcrumb = (event, row) => {
    event.preventDefault();
    dispatch(removeItem(row));
    history.push(row.url);
  };

  return (
    <Container maxWidth="xl" className={classes.breadcrumbContainer}>
      <Breadcrumb
        breadcrumb={breadcrumb}
        navigateBreadcrumb={navigateBreadcrumb}
      />
    </Container>
  );
}
